import { freExpressionPickerText } from './ExpressionPickerScene.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import resolveFREImage from '../utils/resolveFREImage';

import * as React from 'react';

const styles = require('./OptInScene.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function ExpressionPicker(props: {}) {
    return (
        <div className={classNames('prop', 'expression-diptych', 'clear')}>
            <div className={classNames('primary')}>
                <div className={classNames('text-container')}>
                    <div className={classNames('prop', 'i-beam')} />
                    <div className={classNames('text-track')}>{loc(freExpressionPickerText)}</div>
                    <div className={classNames('prop', 'character', 'exclamation-point')}>!</div>
                    <div className={classNames('prop', 'character', 'colon')}>:</div>
                </div>

                <div className={classNames('callout-container')}>
                    <div className={classNames('prop', 'callout-base')}>
                        <div className={classNames('prop', 'emoji-glyph', 'a')}>
                            {String.fromCharCode(0xd83c, 0xdf89)}
                        </div>
                        <div className={classNames('prop', 'emoji-glyph', 'b')}>
                            {String.fromCharCode(0xd83d, 0xdcaf)}
                        </div>
                        <div className={classNames('prop', 'emoji-glyph', 'c')}>
                            {String.fromCharCode(0xd83c, 0xdfc0)}
                        </div>
                    </div>
                </div>

                <div className={classNames('prop', 'cursor')} />
            </div>
            <div className={classNames('secondary')}>
                <div className={classNames('prop', 'gifs-track', 'clear')}>
                    <img src={resolveFREImage('thx.gif')} alt="" role="presentation" />
                    <img src={resolveFREImage('01.gif')} alt="" role="presentation" />
                    <img src={resolveFREImage('clippy.gif')} alt="" role="presentation" />
                    <img src={resolveFREImage('02.gif')} alt="" role="presentation" />
                </div>
            </div>
        </div>
    );
});
